import React from "react";
import { Dropdown } from "antd";
import { Button } from "evergreen-ui";
import { EllipsisOutlined } from "@ant-design/icons";

const TableActionMenu = ({ items = [] }) => {
	const menuItems = items
		.filter((item) => item && typeof item.onClick === "function")
		.map((item) => ({
			key: item.key,
			label: item.label,
			danger: Boolean(item.danger),
		}));

	if (!menuItems.length) {
		return null;
	}

	return (
		<Dropdown
			trigger={["click"]}
			menu={{
				items: menuItems,
				onClick: ({ key, domEvent }) => {
					domEvent.stopPropagation();
					const selectedItem = items.find((item) => item.key === key);
					selectedItem?.onClick?.();
				},
			}}
		>
			<Button
				height={32}
				minWidth={32}
				paddingLeft={8}
				paddingRight={8}
				onClick={(event) => event.stopPropagation()}
			>
				<EllipsisOutlined />
			</Button>
		</Dropdown>
	);
};

export default TableActionMenu;
